import { render, staticRenderFns } from "./looker-embed-plain.vue?vue&type=template&id=a1c58b1a"
import script from "./looker-embed-plain.vue?vue&type=script&lang=js"
export * from "./looker-embed-plain.vue?vue&type=script&lang=js"
import style0 from "./looker-embed-plain.vue?vue&type=style&index=0&id=a1c58b1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports